import { useCallback } from 'react'
import { FormDialog } from 'components/dialog/form'
import { InviteResult } from 'interface/user/invite'
import { useInviteForm, InviteForm } from '../form/add'
import { GroupResult } from 'interface/user/group'

type AddInviteDialogProps = {
  groupList: GroupResult[],
  onAddInvite: (invite: InviteResult) => void
  onClose: () => void
}
export const AddInviteDialog = ({
  groupList,
  onAddInvite,
  onClose
}: AddInviteDialogProps) => {
  const onSubmit = useCallback(
    (result: InviteResult) => {
      onAddInvite(result)
      onClose()
    },
    [onClose, onAddInvite]
  )
  const form = useInviteForm({ groupList, onSubmit })
  return (
    <FormDialog
      open
      fullWidth
      maxWidth="sm"
      title="新規ユーザーを招待"
      isLoading={form.postState.posting}
      error={form.postState.error}
      body={<InviteForm {...form}/>}
      submitLabel="登録"
      isValid={form.formState.isValid}
      onSubmit={form.submit}
      onClose={onClose}
    />
  )
}
